import { DownloadIcon, Menu } from "@codat/orchard-ui";
import { FileOutputType } from "api/public-service";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";
import React from "react";
import { useDownloadReportFile } from "utils/downloadReportFile";
import { formatDateAndTimeWithShortString } from "utils/formatDate";

type DownloadReportProps = {
  companyId: string;
  status: string;
  reportsOverview: {
    outputTypes: FileOutputType[] | undefined;
    reportType: string | undefined;
    lastUpdatedUtc: string | undefined;
  };
};

const getReportLabel = (status: string): string => {
  switch (status) {
    case "excel":
      return "Spend analysis";
    case "spendSummary":
      return "Spend summary";
    case "payTechExcel":
      return "PayTech file";
    case "mastercardMatchExcel":
      return "Mastercard Match file";
    default:
      return status;
  }
};

export const DownloadMenu = ({
  companyId,
  reportsOverview,
}: DownloadReportProps) => {
  const downloadReportFile = useDownloadReportFile();
  const publicApi = usePublicApiService();
  const { outputTypes, reportType, lastUpdatedUtc } = reportsOverview;

  if (!outputTypes || !reportType) {
    return null;
  }

  const downloadableOutputTypes = [
    "spendSummary",
    "excel",
    "mastercardMatchExcel",
    "payTechExcel",
  ];
  const availableReports = outputTypes
    .filter((outputType) => downloadableOutputTypes.includes(outputType))
    .sort((a, b) => {
      return (
        downloadableOutputTypes.indexOf(a) - downloadableOutputTypes.indexOf(b)
      );
    });

  return (
    <>
      {availableReports?.map((outputType) => (
        <Menu.Item
          id="download"
          label={getReportLabel(outputType)}
          subtext={`Last updated: ${
            lastUpdatedUtc
              ? formatDateAndTimeWithShortString(lastUpdatedUtc, true)
              : "No Data Available"
          }`}
          icon={<DownloadIcon />}
          onClick={() =>
            downloadReportFile(
              publicApi.getSpendReport({
                params: {
                  companyId,
                  reportType: reportType,
                  reportId: "latest",
                  outputName: outputType,
                },
              })
            )
          }
          data-testid={`download-${outputType}`}
          key={`download-${outputType}`}
        />
      ))}
    </>
  );
};
